module.exports = "<div class=\"delegated-card-avatar\">\n  <avatar-app ng-if=\"$ctrl.employeeProfile !== undefined\"\n              name=\"$ctrl.employeeProfile.name\"\n              email=\"$ctrl.employeeProfile.email\"\n              user-id=\"$ctrl.employeeProfile.userId\"></avatar-app>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardAvatar/delegatedCardAvatar.html
// module id = 1709
// module chunks = 0